export default __webpack_public_path__ + "static/media/thumbnail.92d83b9e.webp";